// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum CustomerRefundApplicationOrderSourceType {
  Unknown = "UNKNOWN",
  Eshop = "ESHOP",
  Kiosk = "KIOSK",
  Salespoint = "SALESPOINT",
}
export default CustomerRefundApplicationOrderSourceType;
